module.exports = __webpack_public_path__ + "static/media/princeton-2.c901ae45.jpg";